import React from 'react';
import Container from '../elements/container';
import Loader from '../elements/loader';

const NotFound = ({ pathname = '' }) => {
  if (pathname === '/impersonate') {
    return (
      <Container>
        <Loader />
      </Container>
    );
  }
  return <div>NotFound</div>;
};

export default NotFound;
